module.exports = __webpack_public_path__ + "media/images/email/share/play_again-67be179ab7a2b841f120ce1a64310d91.png";